import { TransformDate } from '../../../shared/decorators/transform-date.decorator';
import { TransformInt } from '../../../shared/decorators/transform-int.decorator';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { MapCoordinateDto } from '../../../shared/modules/shared/dtos/map-coordinate.dto';
import { FuelLevelEnum } from '../../shared/enums/fuel-level.enum';

// NOTE: The entity behind this DTO is effectively an owned entity, and is not used outside
// of the context of a parent entity. For this reason, it is not necessary to have a separate
// List or Record versions of it or extend it from the BaseDto.

/**
 * Check-out DTO
 */
export class CheckOutDto {
  @TransformInt()
  id?: number;
  @TransformDate()
  checkOutAt?: Date | null;
  fuelLevel?: FuelLevelEnum | null;
  @TransformInt()
  odometerValue?: number | null;
  notes?: string | null;
  @TransformInt()
  locationId?: number | null;
  locationCode?: string;
  locationName?: string;
  pickUpGpsCoordinates?: MapCoordinateDto | null;
  @TransformInt()
  vehicleId?: number | null;
  vehicleVin?: string;
  vehicleLicensePlate?: string;
  files?: FileDto[] | null;

  markRecordAsInProgress?: boolean;
}
